import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import NavigationDrawer from "../../../components/NavigationDrawer";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import DynamicTabsDrawer from "./../../../components/DynamicTabDrawer";
import Banner from "./Banner";
import DiscountRule from "./DiscountRule";
import EcommerceCategory from "./EcommerceCategory";
import EcommerceSubCategory from "./EcommerceSubCategory";
import EcommerceSubSubCategory from "./EcommerceSubSubCategory";
import EcommerceTags from "./EcommerceTags";
import ServiceCategory from "./ServiceCategory";
import { Attribute } from "./attribute";
import { PromotionalBlock } from "./promotionalBlock";
import CategoryDetails from "./CategoryDetails";
import { CharityOrganization } from "./charityOrganization";
import { Brands } from "./brand";
import { GiftCards } from "./giftCard";
import { BlogTopic } from "./blogTopic";
import { EventCategory } from "./eventCategory";
import { PromoCode } from "./promoCode";

const tabs = [
  { label: "ecommerceCategory", value: "ecommerce_category" },
  { label: "ecommerceSubCategory", value: "ecommerce_sub_category" },
  { label: "ecommerceSubSubCategory", value: "ecommerce_sub_sub_category" },
  { label: "serviceCategory", value: "service_category" },
  { label: "ecommerceTags", value: "ecommerce_tags" },
  { label: "banners", value: "banner" },
  { label: "promotionalImages", value: "promotional_images" },
  { label: "discountRules", value: "discount_rules" },
  { label: "attribute", value: "attribute" },
  { label: "charityOrganizations", value: "charity_organizations" },
  { label: "brands", value: "brands" },
  { label: "giftCards", value: "gift_card" },
  { label: "blogTopics", value: "blog_topic" },
  { label: "eventCategories", value: "event_category" },
  { label: "promoCode", value: "promo_code" },
];

function AdminCatalogue() {
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.activeTab.tabs);

  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, catalogue: tab }));
  };

  const renderTabs = (activeTab) => {
    switch (activeTab) {
      case "ecommerce_category":
        return <EcommerceCategory />;
      case "ecommerce_sub_category":
        return <EcommerceSubCategory />;
      case "ecommerce_sub_sub_category":
        return <EcommerceSubSubCategory />;
      case "service_category":
        return <ServiceCategory />;
      case "category_detail":
        return <CategoryDetails />;
      case "ecommerce_tags":
        return <EcommerceTags />;
      case "banner":
        return <Banner />;
      case "promotional_images":
        return <PromotionalBlock />;
      case "attribute":
        return <Attribute />;
      case "discount_rules":
        return <DiscountRule />;
      case "charity_organizations":
        return <CharityOrganization />;
      case "brands":
        return <Brands />;
      case "gift_card":
        return <GiftCards />;
      case "blog_topic":
        return <BlogTopic />;
      case "event_category":
        return <EventCategory />;
      case "promo_code":
        return <PromoCode />;
      default:
        return null;
    }
  };

  return (
    <NavigationDrawer>
      <Grid container spacing={1}>
        <Grid item xs={12} md={2.3}>
          <DynamicTabsDrawer
            primaryHeading={"catalogue"}
            tabs={tabs}
            activeTab={activeTab.catalogue}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.7}>
          {renderTabs(activeTab.catalogue)}
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
}

export default AdminCatalogue;
